import cloneDeep from "lodash/cloneDeep";
import uuid from "uuid";

import EventManager from "../../../store/sqftEventManager";
import {pnpolyArray} from "../../../../../lib/pnpoly";
import resizeLine, {getMaxResizeWidth} from "./resizeLine";
import config from "../../../store/sqftConfig";
import {
  getPointDistance,
  orientation,
  measureDistanceToInches,
  distanceToMillimeters,
  distanceToInches,
  getFontsize,
  get45CornerLegDistanceByHypotenuse,
  getAngleBetweenTwoPoints,
  getParallelPoints,
  getPointField,
  rotatePoint
} from "../../../../../helpers/sqftHelper";
import COLOR_THEMES, {COLOR} from "../../../store/colorThemes";
import store from "../../../../../../../store";
import {updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import sqftConfig from "../../../store/sqftConfig";
import Config from "../../../../../../../config";
import RenderFigures from "../../../helpers/renderFigures";
import {updateMiteredLength, updateShapeWaterfallLength, updateUnderlaymentLength} from "../../../helpers/lineHelper";

export default function() {
  var self = this,
    state = {
      isHovered: false,
      isEditInputDisplayed: false,
      hoveredColor: "#FF9844",
      textWidth: 0,
      withBumpout: false,
      midPoint: {
        x: 0,
        y: 0,
        xOffset: 0,
        yOffset: 0
      }
    },
    line = null,
    lineText = '',
    lineType = 'edge',  // by default
    lineTextColor = COLOR_THEMES[config.activeTheme].primary;
  this.id = uuid();
  this.isInited = false;
  this.design = {
    offsetFromLineEnd: 15
  }

  function setLine(value) { line = value; }
  this.getLine = () => { return line; }
  function getMidPoint(from, to) {
    return {
      x: from.x + (to.x - from.x)/2,
      y: from.y + (to.y - from.y)/2
    };
  }

  const isMouseOverText = (mousePos) => {
    const lineDirection = line.getLineDirection();
    const pointsArray = this.getHoveredArea();

    return {isHovered: pnpolyArray(pointsArray, mousePos), orientation: lineDirection.orientation};
  }

  this.getHoveredArea = () => {
    const lineDirection = line.getLineDirection();
    let pointsArray = [];
    //console.log("lineDirection.orientation", lineDirection.orientation);
    switch (lineDirection.orientation) {
      case "vertical":
        if (lineDirection.newDirection === "south") {
          pointsArray = [
            [state.midPoint.x + 40, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x + 15, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x + 15, state.midPoint.y + state.textWidth / 2 - 5],
            [state.midPoint.x + 40, state.midPoint.y + state.textWidth / 2 - 5],
          ];
        } else if (lineDirection.newDirection === "north") {
          pointsArray = [
            [state.midPoint.x - 40, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x - 15, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x - 15, state.midPoint.y + state.textWidth / 2 - 5],
            [state.midPoint.x - 40, state.midPoint.y + state.textWidth / 2 - 5],
          ];
        }
        break;
      case "horizontal": {
        pointsArray = [
          [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y - 15],
          [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y - 15],
          [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y + 10],
          [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y + 10],
        ]
        break;
      }
      case "northeast":
      case "northwest":
      case "southeast":
      case "southwest":
      default: {
        let angle = getAngleBetweenTwoPoints(line.from, line.to);
        let pointToRotate1 = {x: state.midPoint.x - state.textWidth / 2 - 10, y: state.midPoint.y - 15};
        let rotatedPoint1 = rotatePoint(pointToRotate1, state.midPoint, angle);
        let pointToRotate2 = {x: state.midPoint.x + state.textWidth / 2 + 10, y: state.midPoint.y - 15};
        let rotatedPoint2 = rotatePoint(pointToRotate2, state.midPoint, angle);
        let pointToRotate3 = {x: state.midPoint.x + state.textWidth / 2 + 10, y: state.midPoint.y + 10};
        let rotatedPoint3 = rotatePoint(pointToRotate3, state.midPoint, angle);
        let pointToRotate4 = {x: state.midPoint.x - state.textWidth / 2 - 10, y: state.midPoint.y + 10};
        let rotatedPoint4 = rotatePoint(pointToRotate4, state.midPoint, angle);
        pointsArray = [
          [rotatedPoint1.x, rotatedPoint1.y],
          [rotatedPoint2.x, rotatedPoint2.y],
          [rotatedPoint3.x, rotatedPoint3.y],
          [rotatedPoint4.x, rotatedPoint4.y],
          // [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y - 15],
          // [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y - 15],
          // [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y + 10],
          // [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y + 10],
        ]
        break
      }
    }
    return pointsArray
  }

  function onMouseMove(mousePos, e) {
    void e;
    const {isHovered, orientation} = isMouseOverText(mousePos);
    state.isHovered = isHovered;
    if (state.isHovered) {
      EventManager.stealCursor();
      EventManager.setCursor((orientation === "horizontal") ? "text" : "text-vertical", self);
    } else {
      EventManager.resetCursor(self);
    }
  }
  const onMouseDown = () => {
    if (state.isHovered && !document.querySelector(".line-input")) {
      window.lineInputFocused = true;
      EventManager.stealCursor();
      state.isEditInputDisplayed = true;
      const ENTER_KEY = 13;
      const input = document.createElement("input");
      input.type = "number";
      input.setAttribute("min", "1");
      input.setAttribute(
        "max",
        Math.round(getMaxResizeWidth(line) * config.getMeasureMultiplier()).toString()
      );

      input.oninput = (e) => {
        let max = Math.round(+e.target.max * config.getMeasureMultiplier());
        if (+e.target.value > max) {
          e.target.value = max;
        }
      };

      const lineDirection = line.getLineDirection();
      if (lineDirection.orientation === "horizontal") {
        input.className = "line-input line-length";
        input.style.left = state.midPoint.x + "px";
        input.style.top = state.midPoint.y + "px";
      } else if (lineDirection.orientation === "vertical") {
        input.className = "line-input";
        input.style.left = state.midPoint.x + "px";
        input.style.top = state.midPoint.y + "px";
      } else {
        input.className = "line-input";
        input.style.left = state.midPoint.x + "px";
        input.style.top = state.midPoint.y + "px";
      }

      input.value = Math.round(self.getLineDistanceFull() * config.getMeasureMultiplier());

      document.querySelector(".sqft-main-grid").appendChild(input);
      input.addEventListener("focus", function() {
        this.select();
      });
      input.focus();

      input.onkeydown = function(e) {
        if (e.keyCode === ENTER_KEY) {
          e.target.blur();
        }
      };

      let blurI = function(e) {
        if (!e.target.closest('.line-input')) {
          input.blur();
        }
      };

      input.onblur = (event) => {
        //trigger change to set value if it is rounded and wasn't changed
        const changeEvent = new Event('change', { bubbles: true });
        event.target.dispatchEvent(changeEvent);

        window.lineInputFocused = false;
        input.parentNode.removeChild(input);
        document.removeEventListener("click", blurI);
        state.isEditInputDisplayed = false;
      };

      input.onchange = (event) => {
        let min = Math.round(+event.target.min * config.getMeasureMultiplier());
        let value = event.target.value;
        if (value.indexOf('.') == 0) {
          value = +("0"+value);   // dot on the beginning
        }
        if (value.toString().indexOf(".") === (value.toString().length - 1)) {
          value = value.substring(0, value.length - 1); // dot on the end
        }
        if (+value < min) {
          value = min
        }
        value = Math.round(+value / config.getMeasureMultiplier() * 100) / 100;

        const shape = line.getParent();
        line.to.rememberPos();
        line.from.rememberPos();
        setNewLineWidth(value - self.getAdditionalLineDistance());
        if (shape.isShapeHasIntersections()) {
          line.to.restorePos();
          line.from.restorePos();
          input.max = event.target.value - 1;
          input.value = event.target.value - 1;
        }
      };

      setTimeout(() => {
        document.addEventListener("click", blurI);
      }, 500);

      return false;
    }
  };

  function setNewLineWidth(lineWidth) {
    const distance = getPointDistance(line.from, line.to);
    const diff = lineWidth - distance;
    const reduxState = store.getState();
    const isWallsLockMode = reduxState.sqftMenuState.isWallsLockMode;
    resizeLine(line, diff, isWallsLockMode);
    updateShapeWaterfallLength(line);
    updateMiteredLength(line);
    updateUnderlaymentLength(line);

    const state = store.getState();
    const updateCalculations = state.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  }
  function getCtxColor(ctx, lineType) {
    return (lineType === "wall")
      ? state.isHovered ? state.hoveredColor : ctx.fillStyle
      : state.isHovered ? state.hoveredColor : COLOR_THEMES[config.activeTheme].primary;
  }
  this.destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(self);
      this.isInited = false
    }
  };
  this.import = (data) => {
    state = data.state;
    this.id = data.id
  };
  this.export = () => {
    return { id: this.id, state: cloneDeep(state) }
  };
  this.init = function(line) {
    setLine(line);
    this.initEvents();
  };
  this.initEvents = () => {
    this.isInited = true;
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      onMouseMove,
      self,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      onMouseDown,
      self,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      self.render,
      self,
      EventManager.priorities.OVERLAY
    );
  };
  this.deregisterEvents = () => {
    EventManager.removeEvent(this);
    this.isInited = false;
  };
  this.reInitEvents = () => {
    if (!this.isInited) {
      this.initEvents();
    }
  };
  this.removeLineText = function () {
    lineText = '';
    lineType = 'edge';  // by default
    lineTextColor = COLOR_THEMES[config.activeTheme].primary;
  };
  this.renderEdgeText = function (edgeName) {
    lineText = edgeName;
    lineType = 'edge';
    lineTextColor = COLOR_THEMES[config.activeTheme].active;
  };
  this.renderBacksplashText = function (backsplashName, type) {
    lineText = backsplashName;
    lineType = type;
    lineTextColor = (type === "wall") ? "#000000" : COLOR_THEMES[config.activeTheme].primary;
  };
  this.getMidpoint = function () {
    return state.midPoint;
  };
  this.setMidpointOffset = function (xOffset, yOffset) {
    state.midPoint.xOffset = xOffset;
    state.midPoint.yOffset = yOffset;
  };
  this.getLineLength = function () {
    var distance = getPointDistance(line.from, line.to);

    return measureDistanceToInches(distance);
  };
  this.getLineLengthText = function () {
    let distance = this.getLineDistanceFull();

    return config.measureUnit === "Metric" ? distanceToMillimeters(distance) : distanceToInches(distance);
  };
  this.getLineDistanceFull = function () {
    return getPointDistance(line.from, line.to) + this.getAdditionalLineDistance();
  };
  this.getLineDistanceFullInPixels = function () {
    const lineLengthInPx = getPointDistance(line.calculateRenderPosition(line.from), line.calculateRenderPosition(line.to));
    const scale = config.scale;
    let additionalLineDistance = this.getAdditionalLineDistance() * scale;
    if (additionalLineDistance < 0) {
      additionalLineDistance -= this.design.offsetFromLineEnd; // add gray line margin
    } else if (additionalLineDistance > 0) {
      additionalLineDistance += this.design.offsetFromLineEnd; // add gray line margin
    }

    return lineLengthInPx + additionalLineDistance;
  };
  this.getAdditionalLineDistance = function () {
    let additionalDistance = 0;
    const prevLine = line.getParent().getPrevLine(line);
    if (line.to.angle > 0 || line.to.arcLength > 0) {
      additionalDistance -= get45CornerLegDistanceByHypotenuse(line.to.angle || line.to.arcLength);
    }

    if (prevLine.to.angle > 0 || prevLine.to.arcLength > 0 ) {
      additionalDistance -= get45CornerLegDistanceByHypotenuse(prevLine.to.angle || prevLine.to.arcLength);
    }

    return +additionalDistance;
  };

  this.render = function(ctx) {
    if (state.isEditInputDisplayed) {
      return;
    }

    let scale = config.scale,
      fontSize = getFontsize(),
      font = (fontSize).toString() + "px " + config.activeFontBold,
      lineDirection = line.getLineDirection(),
      offset = line.getOffset(),
      distance = this.getLineDistanceFullInPixels(),
      dstring = this.getLineLengthText(),
      midPoint = getMidPoint(line.from, line.to),
      orientationValue = line.getOrientation(),
      space,
      mtext,
      medgeText,
      xOffset = 0,
      yOffset = 0,
      lineCornerWidth = 0,
      fromPosOnField = getPointField(line.from.x, line.from.y, line);

    let prevLine;
    const parent = line.getParent();

    ctx.beginPath();
    ctx.font = font;

    mtext     = ctx.measureText(dstring);
    medgeText = ctx.measureText(lineText);
    space     = ctx.measureText(' ');
    state.textWidth = Math.round(mtext.width * 100) / 100;

    let marginTotal = 0;

    for (let i in lineDirection.cornerMargins) {
      marginTotal += lineDirection.cornerMargins[i];
    }

    if (medgeText.width + ctx.measureText(dstring).width > distance ) {
      fontSize = 14;
      ctx.font = "14px " + config.activeFontBold;
      mtext     = ctx.measureText(dstring);
      medgeText = ctx.measureText(lineText);
      space     = ctx.measureText(' ');

      switch (lineDirection.orientation) {
        case "horizontal": {
          break;
        }
        case "vertical": {
          if (lineDirection.newDirection === "south") {
            xOffset = 7;
          } else if (lineDirection.newDirection === "north") {
            xOffset = -7;
          }
          break;
        }
      }
      if (distance < 20 * config.scale + marginTotal * 40) {
        lineText  = '';
        medgeText = ctx.measureText(lineText);
      } else {
        if (lineText && (medgeText.width + ctx.measureText(dstring).width > distance - marginTotal * 40)) {
          while (medgeText.width && (medgeText.width + ctx.measureText(dstring).width > distance - marginTotal * 40)) {
            lineText = lineText.slice(0, - 1);
            medgeText = ctx.measureText(lineText);
          }
        }
      }
    }

    lineCornerWidth += line.get45CornerLegDistance() / 2 * scale;
    prevLine = parent.getPrevLine(line);
    lineCornerWidth -= prevLine.get45CornerLegDistance() / 2 * scale;

    midPoint.y = midPoint.y * scale + offset.y;
    midPoint.x = midPoint.x * scale + offset.x;
    ctx.textAlign = "center";
    //midPoint.y += fontSize / 2;
    // ctx.fillStyle = "rgba(255,255,255,0)";
    // ctx.fillRect(midPoint.x - tLen/2 - 4, midPoint.y - (fontSize), tLen + 4, fontSize + 4);
    ctx.beginPath();
    ctx.fillStyle = state.isHovered
      ? state.hoveredColor
      : (lineType === "wall") ? "#000000" : COLOR_THEMES[config.activeTheme].primary;

    let marginFrom = 0,
      marginTo = 0;

    switch (lineDirection.orientation) {
      case "horizontal": {
        if (lineDirection.newDirection === "east") {
          midPoint.x -= lineCornerWidth;
          marginFrom = (lineDirection.cornerMargins.fromLeft) ? marginFrom + 9 : marginFrom;
          marginTo = (lineDirection.cornerMargins.fromRight) ? marginTo + 9 : marginTo;
        } else if (lineDirection.newDirection === "west") {
          midPoint.x += lineCornerWidth;
          marginFrom = (lineDirection.cornerMargins.fromRight) ? marginFrom + 9 : marginFrom;
          marginTo = (lineDirection.cornerMargins.fromLeft) ? marginTo + 9 : marginTo;
        }
        yOffset = (lineDirection.newDirection === "west" ? 33 : -20) + (state.midPoint.yOffset  * scale);
        if (lineText) {
          ctx.fillStyle = lineTextColor;
          ctx.wrapText(lineText, midPoint.x - mtext.width / 2 - marginFrom + marginTo, midPoint.y + yOffset, medgeText, fontSize);
          ctx.fillStyle = getCtxColor(ctx, lineType);
          state.midPoint.x = midPoint.x + medgeText.width / 2 + space.width - marginFrom + marginTo;
          state.midPoint.y = midPoint.y + yOffset;
        } else {
          state.midPoint.x = midPoint.x - marginFrom + marginTo;
          state.midPoint.y = midPoint.y + yOffset;
        }
        ctx.wrapText(dstring, state.midPoint.x, state.midPoint.y, mtext, fontSize);
        break;
      }
      case "vertical": {
        if (lineDirection.newDirection === "south") {
          marginFrom = (lineDirection.cornerMargins.fromTop) ? marginFrom + 9 : marginFrom;
          marginTo = (lineDirection.cornerMargins.fromBottom) ? marginTo + 9 : marginTo;
          midPoint.y -= lineCornerWidth;
        } else if (lineDirection.newDirection === "north") {
          marginTo = (lineDirection.cornerMargins.fromTop) ? marginTo + 9 : marginTo;
          marginFrom = (lineDirection.cornerMargins.fromBottom) ? marginFrom + 9 : marginFrom;
          midPoint.y += lineCornerWidth;
        }
        xOffset += state.midPoint.xOffset * scale;
        state.midPoint.x = midPoint.x + xOffset;
        state.midPoint.y = lineText
          ? lineDirection.newDirection === "south"
            ? midPoint.y + medgeText.width / 2 + space.width
            : midPoint.y - medgeText.width / 2 + space.width
          : midPoint.y;
        ctx.save();
        ctx.translate(
          lineDirection.newDirection === "south" ? midPoint.x + xOffset : midPoint.x + xOffset,
          lineDirection.newDirection === "south" ? midPoint.y - 5 : midPoint.y - 10
        );
        ctx.rotate(lineDirection.newDirection === "south" ? Math.PI / 2 : -Math.PI / 2);
        if (lineText) {
          ctx.fillStyle = lineTextColor;
          ctx.wrapText(lineText, 0 - mtext.width / 2 + marginFrom - marginTo, -fontSize, medgeText, fontSize);
          ctx.fillStyle = getCtxColor(ctx, lineType);
          ctx.wrapText(dstring, 0 + medgeText.width / 2 + space.width + marginFrom - marginTo, -fontSize - yOffset, mtext, fontSize);
        } else {
          ctx.wrapText(dstring, 0 + marginFrom - marginTo, -fontSize, mtext, fontSize);
        }
        break;
      }
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST": {
        ctx.save();
        if (lineText) {
          dstring = lineText + ' ' + dstring;
        }
        //this.renderFrameBorder(ctx, dstring, fontSize, midPoint, orientationValue);
        const [parallelPoint1] = getParallelPoints(fromPosOnField, midPoint, -30);
        state.midPoint.x = parallelPoint1.x;
        state.midPoint.y = parallelPoint1.y;
        this.renderText(ctx, dstring, state.midPoint, fontSize, orientationValue);
        break;
      }
      default:
        break;
    }

    ctx.restore();

    if (Config.isDevMode()) {
      this.renderHoveredArea(ctx);
    }
  };

  this.renderHoveredArea = (ctx) => {
    //console.log("state.midPoint.", state.midPoint);
    const hoveredArea = this.getHoveredArea();
    ctx.beginPath();
    ctx.moveTo(hoveredArea[0][0], hoveredArea[0][1]);
    ctx.lineTo(hoveredArea[1][0], hoveredArea[1][1]);
    ctx.lineTo(hoveredArea[2][0], hoveredArea[2][1]);
    ctx.lineTo(hoveredArea[3][0], hoveredArea[3][1]);
    ctx.lineTo(hoveredArea[0][0], hoveredArea[0][1]);
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)';
    ctx.stroke();
    ctx.closePath();
  }

  this.getFrameBorderPosition = (ctx, pos, value, fontHeight, orientationValue) => {
    const mText = ctx.measureText(value);
    let position = {
      x: pos.x,
      y: pos.y
    };

    switch (orientationValue) {
      case orientation.HORIZONTAL: {
        break;
      }
      case orientation.VERTICAL: {
        break;
      }
      case orientation.NORTHWEST: {
        position = {
          x: pos.x - mText.width,
          y: pos.y - this.design.offsetFromLineEnd
        };
        break;
      }
      case orientation.NORTHEAST: {
        position = {
          x: pos.x - mText.width,
          y: pos.y - this.design.offsetFromLineEnd
        };
        break;
      }
      case orientation.SOUTHWEST: {

        break;
      }
      case orientation.SOUTHEAST: {

        break;
      }
      default:
        break;
    }
    return position
  }

  this.renderFrameBorder = (ctx, value, fontHeight, pos, orientationValue) => {
    ctx.beginPath();
    const mText = ctx.measureText(value);
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
    ctx.lineWidth = 2;
    ctx.fillStyle = COLOR.white

    const angle = getAngleBetweenTwoPoints(line.from, line.to);
    let position = this.getFrameBorderPosition(ctx, pos, value, fontHeight, orientationValue);

    ctx.save();
    ctx.translate(
      position.x,
      position.y,
    );
    ctx.rotate(angle * (Math.PI / 180));
    RenderFigures.roundedRect(ctx,
      0, // absolute pos: //pos.x - mText.width / 1.25 / sqftConfig.scale * sqftConfig.defaultScale,
      0, // absolute pos: //pos.y - fontHeight,
      mText.width * 1.5 + sqftConfig.scale / sqftConfig.defaultScale,
      fontHeight + 6,
      5,
      true,
      true
    );
    ctx.restore();
    ctx.closePath();
  }

  this.renderText = (ctx, value, pos, fontHeight, orientationValue) => {
    const //scale = sqftConfig.scale,
      font = fontHeight + "px " + config.activeFontBold,
      mText = ctx.measureText(value);

    //let position = this.getTextPosition(ctx, pos, value, fontHeight, orientationValue);

    ctx.beginPath();
    ctx.font = font;
    ctx.textAlign = "center";
    ctx.fillStyle = getCtxColor(ctx, lineType);

    let angle = getAngleBetweenTwoPoints(line.from, line.to);
    //this will help to rotate upside down text
    if ([orientation.NORTHWEST, orientation.SOUTHWEST].indexOf(orientationValue) !== -1) {
      angle += 180;
    }
    ctx.save();
    //RenderFigures.renderCircle(pos, 5,1, '#284da8');
    ctx.translate(
      pos.x,
      pos.y
    );
    ctx.rotate(angle * (Math.PI / 180));
    //ctx.wrapText(value, fontHeight / 2,  mText.width / ( 2 * scale), mText, fontHeight);
    ctx.wrapText(value, 0,  0, mText, fontHeight);
    ctx.restore();
    ctx.closePath();
  }
}
